import React, { useState } from 'react';
import { apiPost } from '../utils/api';

const PercentageCalculator = () => {
  const [value, setValue] = useState('');
  const [percent, setPercent] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCalculate = async () => {
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/utils/percentage', { value, percent });
      setResult(data.result);
    } catch (e) {
      setResult('Erro ao calcular porcentagem.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Calculadora de Porcentagem</h2>
      <p className="mb-4 text-gray-600">Calcule porcentagens facilmente. Exemplo: quanto é 15% de 200?</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-4">
        <input
          type="number"
          min={0}
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Valor"
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <input
          type="number"
          min={0}
          value={percent}
          onChange={e => setPercent(e.target.value)}
          placeholder="%"
          className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={handleCalculate}
          disabled={loading || !value || !percent}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50 w-full"
        >
          {loading ? 'Calculando...' : 'Calcular'}
        </button>
      </div>
      {result !== null && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-lg text-center font-mono text-gray-800">
          Resultado: {result}
        </div>
      )}
    </div>
  );
};

export default PercentageCalculator; 